import { DOMAINS, REALMS, SITES, LOCALES } from '../gen/lang.js';
import { getCookie, setCookie } from './cookieService.js';

const isBitiba = (domain) => {
    return /(bitiba)/.test(domain);
};
const toUnderscoreLocale = (locale) => {
    const [lang, country] = locale.split('-');
    return `${lang}_${country.toUpperCase()}`;
};
const isSupportedDomain = (domain) => {
    return DOMAINS.includes(domain);
};
const isSupportedRealm = (realm) => {
    return REALMS.includes(realm);
};
const findSiteByDomain = (domain) => {
    return SITES.find((site) => site.domain === domain);
};
const findSiteById = (siteId) => {
    return SITES.find((site) => site.id === siteId);
};
const findSiteByLocale = (realm, locale) => {
    return SITES.find((site) => {
        return (site.realm === realm &&
            (site.locale === locale || !!site.alternateLocales.find((alt) => alt.locale === locale)));
    });
};
const findSiteFromUrl = () => {
    const domainRegex = /[\w-]+\.?\w{2}?\.\w{2,3}$/;
    const currentCountry = window.location.hostname.match(domainRegex);
    return SITES.find((site) => site.domain === currentCountry?.[0]);
};
const findLocaleFromUrlAndCookie = () => {
    const site = findSiteFromUrl();
    if (!site) {
        return 'de-DE';
    }
    // we get locale from cookie only for sites that have more than one defined locale
    if (site.alternateLocales.length) {
        const split = window.location?.pathname?.split('/') || [];
        const urlLanguage = split[1];
        const language = site.language === urlLanguage
            ? site.locale
            : site.alternateLocales.find((alt) => alt.language === urlLanguage)?.locale;
        if (language) {
            return language;
        }
        const cookieLanguage = getCookie('_zpLanguage');
        if (cookieLanguage) {
            return site.language === cookieLanguage
                ? site.locale
                : site.alternateLocales.find((alt) => alt.language === cookieLanguage)?.locale;
        }
    }
    return site.locale;
};
const setLocaleCookie = (site, locale) => {
    // we only set a locale cookie for sites that have more than one defined locale
    if (site.alternateLocales.length && isSupportedLocale(locale, site.id)) {
        return setCookie('_zpLanguage', getLanguageFromLocale(locale), 180);
    }
};
const isSupportedLocale = (locale, siteId) => {
    if (!siteId) {
        return LOCALES.includes(locale);
    }
    const site = findSiteById(siteId);
    return site.locale === locale || site.alternateLocales.some((alt) => alt.locale === locale);
};
const isSupportedLanguage = (site, language) => {
    return (site.language === language || site.alternateLocales.some((alt) => alt.language === language));
};
const getLanguageFromLocale = (locale) => {
    return locale.substring(0, locale.indexOf('-'));
};
const getCountryFromLocale = (locale) => {
    return locale.substring(locale.indexOf('-') + 1);
};
const getLocaleFromLanguage = (site, language) => {
    return site.language === language
        ? site.locale
        : site.alternateLocales.find((alt) => alt.language === language)?.locale;
};
const getLanguage = (site, locale) => {
    const language = site.locale === locale
        ? site.language
        : site.alternateLocales.find((altLocale) => altLocale.locale === locale)?.language;
    if (!language) {
        throw new Error(`Unsupported locale ${locale} for site ${site.id}.`);
    }
    return language;
};

export { findLocaleFromUrlAndCookie, findSiteByDomain, findSiteById, findSiteByLocale, findSiteFromUrl, getCountryFromLocale, getLanguage, getLanguageFromLocale, getLocaleFromLanguage, isBitiba, isSupportedDomain, isSupportedLanguage, isSupportedLocale, isSupportedRealm, setLocaleCookie, toUnderscoreLocale };
//# sourceMappingURL=langService.js.map
